import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LiveMatches from './components/LiveMatches';
import CategoryGrid from './components/CategoryGrid';
import LatestNews from './components/LatestNews';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '开体育在线',
    url: 'https://www.kaitiyu.com/',
    description: '开体育在线是您首选的体育赛事在线服务平台，涵盖足球、篮球、网球等多项赛事直播与数据分析。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.kaitiyu.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <SEOHead
        title="开体育在线 - 官方体育赛事在线平台"
        description="开体育在线是您首选的体育赛事在线服务平台，涵盖足球、篮球、网球等多项赛事直播与数据分析，随时随地享受专业体育在线体验，立即加入开体育在线，畅享全方位体育娱乐服务。"
        keywords="开体育在线,开体育在线平台,体育赛事在线直播,在线体育投注,体育数据分析在线,体育赛事直播平台,实时体育在线服务"
        canonicalUrl="https://www.kaitiyu.com/"
      />

      <Navbar />

      <main>
        <HeroSection />
        <LiveMatches />
        <CategoryGrid />
        <LatestNews />
        <StatsSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}